var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisconnected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5199",
    x1: 76.89,
    x2: 84.213,
    y1: 96.73,
    y2: 96.73,
    gradientTransform: "matrix(1.2729,0,0,1.2729,-22.91,-26.356)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0907 -270.54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5713,0,0,1.5713,-114.97,131.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75.463 99.915 7.7607-6.4212-3.7847-3.1468v12.779l3.8059-3.3807-7.8564-6.4637",
    fill: "none",
    stroke: "url(#linearGradient5199)",
    strokeWidth: 1.3471
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisconnected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/disconnected.797201a4262aaaeb8ec1572650f95413.svg";